import React, { useState } from "react";
import { Grid, Tooltip, IconButton } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import ToolsList from "Constants/ToolsList";
import { ReactSVG } from "react-svg";
import { onSelectTools } from "Stores/actions";
import ToolGroupButton from "Components/ToolGroupButton/ToolGroupButton";
import Addons from "./components/Addons";
import FoldSlide from "./components/FoldSlide";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { DESIGN_RESCALE } from "Stores/actionTypes";
import showNotify from "Helpers/Notify";

export default function ToolsSideDrawer({ rtl }) {
  const { t } = useTranslation();
  const { selectedTool, unitInfo } = useSelector((state) => ({
    selectedTool: state.design.selectedTool,
    unitInfo: state.design.unitInfo,
  }));
  const dispatch = useDispatch();
  const [openDialogAddons, setOpenDialogAddons] = useState(false);
  const [show, setShow] = useState(true);
  const [openDialogFoldSlide, setOpenDialogFoldSlide] = useState(false);

  const onClickTool = (value) => {
    if (value.type === "addons") {
      setOpenDialogAddons(true);
    } else if (value.type === "foldSlide") {
      setOpenDialogFoldSlide(true);
    } else {
      dispatch(onSelectTools(value));
    }
  };

  const handleDialogAddons = () => setOpenDialogAddons(!openDialogAddons);
  const handleDialogFoldSlide = () =>
    setOpenDialogFoldSlide(!openDialogFoldSlide);

  const togglePart = (status) => {
    if (
      window.location.pathname.split("/design/unit/").length > 1 &&
      window.location.pathname.split("/design/unit/")[1] !== ""
    ) {
      setShow(status);
      dispatch({ type: DESIGN_RESCALE, tun: true });
    } else {
      showNotify({
        text: t("toolsSideDrawerWarning"),
        customClass: "warning",
      });
    }
  };

  return (
    <div className={`tools-side-drawer show-${show}`}>
      {!unitInfo ? (
        <div className="inactive">
          <Icons.SlashSquare />
          <p>{t("toolsSideDrawerWarning")}</p>
        </div>
      ) : (
        <div className="active">
          {Object.keys(ToolsList).map((key) => {
            return (
              <>
                {ToolsList[key].filter((item) =>
                  item.auth?.includes(unitInfo["Sys_tak_joft"])
                ).length !== 0 && (
                  <Grid container spacing={1} key={key} className="inner-group">
                    {ToolsList[key]
                      .filter((item) =>
                        item.auth?.includes(unitInfo["Sys_tak_joft"])
                      )
                      .map((item) => {
                        return (
                          <Grid key={item.key} item className={`item ${key}`}>
                            {!item.sub ? (
                              <Tooltip title={t(item.title)}>
                                <IconButton
                                  disabled={item.disabled && item.disabled.every((key) => unitInfo[key] === 0)}
                                  className={`designButton ${
                                    selectedTool.key === item.key && "active"
                                  }`}
                                  onClick={() => onClickTool(item)}
                                >
                                  <ReactSVG src={item.icon} />
                                </IconButton>
                              </Tooltip>
                            ) : (
                              <ToolGroupButton
                                selectedTool={selectedTool}
                                onClick={onClickTool}
                                options={item.sub}
                                unitInfo={unitInfo}
                                onClickSelect={true}
                                disabled={
                                  item.disabled2
                                    ? unitInfo[item.disabled] === 0 &&
                                      unitInfo[item.disabled2] === 0
                                    : unitInfo[item.disabled] === 0
                                }
                              />
                            )}
                          </Grid>
                        );
                      })}
                  </Grid>
                )}
              </>
            );
          })}
          <Addons
            openDialog={openDialogAddons}
            handleDialog={handleDialogAddons}
          />
          <FoldSlide
            openDialog={openDialogFoldSlide}
            handleDialog={handleDialogFoldSlide}
          />
        </div>
      )}
    </div>
  );
}
